<!-- The Zoom row under a crop dialog's image (#crop-image): the label, then a slider in the brand
     green across the rest of the row. A native range input, so mouse, touch and keyboard work;
     only its look is replaced (the browser's blue track and thumb). -->

<template>
  <label class="zoomRow">
    <span class="zoomLabel">Zoom</span>
    <input
      v-model="zoomValue"
      class="zoom"
      type="range"
      min="0"
      max="1"
      step="0.01"
      :style="{'--zoom-fill': Number(zoomValue)}"
    />
  </label>
</template>

<script setup>
const zoomValue = defineModel({type: [Number, String], required: true});
</script>

<style scoped>
.zoomRow {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: var(--space-small, 0.5rem);
}
.zoomRow .zoomLabel {
  font-size: 15px;
  font-weight: 400;
  color: #4a4a4a !important; /* above the dialog's all-black text */
}
/* global.css styles every input as a text field: reset that; 24px tall for an easy target */
.zoom {
  flex: 1;
  min-width: 0;
  height: 24px;
  margin: 0;
  padding: 0;
  border: none;
  border-radius: 0;
  box-shadow: none;
  background: transparent;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
}
/* the green ends under the thumb's centre, which travels 8px in from each end */
.zoom::-webkit-slider-runnable-track {
  height: 5px;
  border-radius: 3px;
  background: linear-gradient(
    to right,
    var(--brand-color) calc(8px + var(--zoom-fill) * (100% - 16px)),
    #c4c4c4 0
  );
}
.zoom::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 16px;
  height: 16px;
  margin-top: -5.5px;
  border: none;
  border-radius: 50%;
  background: var(--brand-color);
}
.zoom::-moz-range-track {
  height: 5px;
  border-radius: 3px;
  background: #c4c4c4;
}
.zoom::-moz-range-progress {
  height: 5px;
  border-radius: 3px;
  background: var(--brand-color);
}
.zoom::-moz-range-thumb {
  width: 16px;
  height: 16px;
  border: none;
  border-radius: 50%;
  background: var(--brand-color);
}
/* the dialogs' focus ring (2px, dark green, 2px off), drawn round the thumb, not the row */
.zoom:focus-visible {
  outline: none !important;
}
.zoom:focus-visible::-webkit-slider-thumb {
  box-shadow: 0 0 0 2px white, 0 0 0 4px var(--brand-dark-color);
}
.zoom:focus-visible::-moz-range-thumb {
  box-shadow: 0 0 0 2px white, 0 0 0 4px var(--brand-dark-color);
}
</style>
